var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouseSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fill: "#52575C",
    fillRule: "evenodd",
    d: "M12.614 1.21c-.361-.28-.867-.28-1.228 0l-9 7C2.142 8.4 2 8.692 2 9v11c0 .796.316 1.559.879 2.121C3.44 22.684 4.204 23 5 23h14c.796 0 1.559-.316 2.121-.879.563-.562.879-1.325.879-2.121V9c0-.309-.142-.6-.386-.79l-9-7zM16 21h3c.265 0 .52-.105.707-.293.188-.187.293-.442.293-.707V9.49l-8-6.223-8 6.222V20c0 .265.105.52.293.707.187.188.442.293.707.293h3v-9c0-.552.448-1 1-1h6c.552 0 1 .448 1 1v9zm-6 0v-8h4v8h-4z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseSvg);
export default __webpack_public_path__ + "static/media/houseSvg.ecd4f76de2ff1fc03524a8a7dc274f96.svg";
export { ForwardRef as ReactComponent };